import { fetchServer } from "@/features/utils/fetch-server";
import { useQuery } from "@tanstack/react-query";
import type { Session } from "../types";

// Fetch a public session by public_id
export function usePublicSession(publicId: string | undefined) {
  return useQuery({
    queryKey: ["public-session", publicId],
    queryFn: async (): Promise<Session> => {
      const response = await fetchServer(
        `/api/sessions/v1/public/${publicId}`,
        {
          credentials: "include", // In case cookies are needed
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch session");
      }

      return response.json();
    },
    enabled: !!publicId,
  });
}
